export class SideEffectLogs {
  id?: number;
  severity: number;
  comment?: string;
  logDate?: Date;
  patientId: number;
  sideEffect: string;
  sideEffectId: number;
  severityDescription?: string;
  color?: string;
  others?: SideEffectLogs[] = [];
  cellBgndClass: string;
  btnClass: string;
  alertKey?: string;
}
